<template>
  <div class="loading">
      <img src="@/assets/oval.svg" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import "loading.scss";
</style>